import { Component, HostListener, OnInit } from '@angular/core';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { PrivateFolderImplementation } from '@mainrepo/app/core/implementation/PrivateFolderImplementation';
import { TwoFactorImplementation } from '@mainrepo/app/core/implementation/twoFactorImplementation';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  selector: 'common-otp-verification',
  standalone: true,
  imports: [DependenciesModule],
  templateUrl: './otp-verification.component.html',
  styleUrl: './otp-verification.component.scss'
})
export class OtpVerificationComponent implements OnInit {
  deviceService: any;
  universalService: any;
  localStorageSvc: any;
  userLoginController: any;
  implRef: any;
  otpVerificationModuleType: any;
  showOTPVerificationPopUp : boolean = false;
  sentSource: any;
  requestNewOTPCountdown: number;
  OtpInterval: any;
  showTimer: boolean;
  differentTitleRequired : boolean = false;


  constructor(public globalService: GlobalService) {
      this.setEnvObjects();
  }

  @HostListener('document:keydown', ['$event'])
    onKeyDownHandler(event: KeyboardEvent) {
      if (event.key === "Enter" && this.showOTPVerificationPopUp) {
        this.verifyOTP();
      }
  }

  setEnvObjects() {
    this.deviceService = this.globalService.getDeviceServiceRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
  }
  
  ngOnInit(): void {
    this.userLoginController = UserloginController.getInstance(this.globalService);
    this.implRef = this.userLoginController.userLoginImplementation;
    AppEvents.globalObservable.subscribe(ev=>{
      if(ev["otpverificationrequired"]){
        this.resetValuesOnOTPVerification(ev);
      }else if(ev["otpverificationerror"]){
        this.implRef.isOTPLoginError = true;
        this.implRef.enableButton = false;
        this.implRef.exception.errorMessage = ev["message"];
        this.resetOTPFields();
      }else if(ev['showerroronsigninscreen']){

      } else{
        this.showOTPVerificationPopUp = false;
        this.otpVerificationModuleType = "";
      }
    })
  }
  
  resetValuesOnOTPVerification(ev){
    this.startTimer();
    this.otpVerificationModuleType = ev["moduleType"];
    this.differentTitleRequired = ev["differentTitleRequired"] ? ev["differentTitleRequired"] : false;
    this.implRef.enableButton = false;
    this.implRef.isOTPLoginError = false;
    this.implRef.exception.errorMessage = "";
    this.implRef.enteredOtp = "";
    this.showOTPVerificationPopUp = true;
    this.sentSource = ev["source"] ? ev["source"] : "";
    this.resetOTPFields();
  }

  async enable2FA(){
    try {
      let twoFAImpl = TwoFactorImplementation.getInstance(this.globalService);
      this.universalService.showLoader = true;
      await twoFAImpl.enable2FA(this.implRef.enteredOtp)
    } catch (e) {
      this.implRef.enableButton = false;
      this.resetOTPFields();
    }
    
  }
  
  async enablePrivateFolderFlow(){
    try {
      let privateFolderImpl = PrivateFolderImplementation.getInstance(this.globalService);
      this.universalService.showLoader = true;
      await privateFolderImpl.enablePrivateFolder(this.implRef.enteredOtp)
    } catch (e) {
      this.implRef.enableButton = false;
      this.resetOTPFields();
    }
  }

  validateOTP(fromId, toId, e) {
    this.userLoginController.setEnvObjects(this.globalService);
    this.userLoginController.otpValidation(fromId, toId, e,'digits');
  }
  
  closeOTPPopup() {
    if(this.otpVerificationModuleType == "twofa"){
      this.universalService.show2FApopUp = true;
      this.universalService.showPassPhraseReset= false;
      let twoFAImpl = TwoFactorImplementation.getInstance(this.globalService);
      twoFAImpl.close2FAOTP();
    }else if(this.otpVerificationModuleType == "privatefolder"){
      AppEvents.privateFolderOperations.next({"resetPFPassword":true});
    }else{
      this.implRef.isOTPLoginError = false;
    }
    this.showOTPVerificationPopUp = false;
    // else if(this.universalService.isTroubledInSigningInFlowOn){
    //   this.implRef.showSendOtpModal = true;
    //   this.universalService.customerTroubleLogin = true;
    // }else{
    //   this.implRef.enteredOtp = "";
    //   this.implRef.exception.errorMessage = "";
    // }
  }
  
  getPassPhraseOTP(resend=false){
    let twoFAImpl = TwoFactorImplementation.getInstance(this.globalService);
    if(this.universalService.tempPassPhrase.length>0){
      twoFAImpl.sendOTP(this.universalService.tempPassPhrase,resend)
    }
  }
  
  getPrivateFolderOTP(resend=false){
    let privateFolderImpl = PrivateFolderImplementation.getInstance(this.globalService);
    if(privateFolderImpl.userCustomPassword.length>0){
      privateFolderImpl.sendOTP(privateFolderImpl.userCustomPassword,resend);
    }
  }
  
  onPasteOtp(ev){
    let el = document.querySelectorAll('.enterOtp');
    var clip = ev.clipboardData.getData('text').trim();
    if (!/\d{6}/.test(clip)) return ev.preventDefault()
    let s = clip.split('');
    el.forEach(function (element,i) {
      let elId = document.querySelector('#' + element.id) as any;
      elId.value = s[i];
      elId.focus();
    });
  }

  async resendOTP(){
    this.resetOTPFields();
    if(this.otpVerificationModuleType == "icloud"){
      this.implRef.isOTPLoginError = false;
      this.implRef.enableButton = false;
      AppEvents.emit(EventsList.RESEND_APPLE_2FA_TOKEN);
    }else  if(this.otpVerificationModuleType == "privatefolder"){
      this.getPrivateFolderOTP();
    }else if(this.otpVerificationModuleType == "twofa"){
      this.getPassPhraseOTP();
    }
  }


  verifyOTP(){
    this.universalService.showLoader = true;
    if(this.otpVerificationModuleType == "icloud"){
      AppEvents.optionSelected.next({"validateicloud2fa":true,"otp":this.implRef.enteredOtp})
    }else  if(this.otpVerificationModuleType == "privatefolder"){
      this.enablePrivateFolderFlow();
    }else if(this.otpVerificationModuleType == "twofa"){
      this.enable2FA();
    }
  }
  
  resetOTPFields(){
    for (var i = 1; i < 7; i++) {
      if (<HTMLInputElement>document.getElementById("digits" + i) != null) {
        (<HTMLInputElement>document.getElementById("digits" + i)).value = "";
      }
    }
    setTimeout(() => {
    (<HTMLInputElement>document.getElementById("digits1")).focus();
    }, 100);
    
  }



  startTimer(){
    var count = 30;
    this.showTimer = true;
	  this.requestNewOTPCountdown = count;
    window.clearInterval(this.OtpInterval)
    this.OtpInterval = setInterval(() => {
      count = count - 1;
      count = count < 0 ? count = 0 : count;
      if (count != 0) {
        this.requestNewOTPCountdown = count;
      } else {
        this.showTimer = false;
        this.requestNewOTPCountdown = 0;
        window.clearInterval(this.OtpInterval)
      }
    }, 1000)
  }
}
